import React from "react";
import { FaEdit, FaEyeSlash } from "react-icons/fa";
import { FaPencil, FaRegEye } from "react-icons/fa6";
import { IoMdTrash } from "react-icons/io";
import { MdOutlineCancel, MdPrint } from "react-icons/md";
import { FiSend } from "react-icons/fi";
import { FaBarcode, FaCheck, FaUndo } from "react-icons/fa";
const EditIcon = ({ iconSize = "17", onClick, className, title = "" }) => {
  return (
    <FaEdit
      size={iconSize}
      className={`text-gray-500 mx-2 cursor-pointer ${className}`}
      onClick={onClick}
      title={title}
    />
  );
};
const DeleteIcon = ({ iconSize = "17", onClick, className, title = "" }) => {
  return (
    <IoMdTrash
      size={iconSize}
      className={`text-red-500 ${className} cursor-pointer`}
      onClick={onClick}
      title={title}
    />
  );
};
const EyeIcon = ({ iconSize = "15", onClick, title = "" }) => {
  return (
    <FaRegEye
      size={iconSize}
      className="text-blue cursor-pointer"
      onClick={onClick}
      title={title}
    />
  );
};
const EyeSlashIcon = ({ iconSize = "15", onClick }) => {
  return (
    <FaEyeSlash
      size={iconSize}
      className="text-blue cursor-pointer"
      onClick={onClick}
    />
  );
};
const PencilIcon = ({ iconSize = "15", onClick }) => {
  return (
    <FaPencil
      size={iconSize}
      className="text-gray-500 cursor-pointer"
      onClick={onClick}
    />
  );
};

const CancelIcon = ({ iconSize = "15", onClick, title = "" }) => {
  return (
    <MdOutlineCancel
      size={iconSize}
      className="text-red-500 cursor-pointer"
      title={title}
      onClick={onClick}
    />
  );
};

const PrintIcon = ({
  iconSize = "15",
  onClick,
  title = "Print",
  disabled = false,
}) => {
  return (
    <MdPrint
      size={iconSize}
      className="text-blue cursor-pointer disabled:text-blue/20"
      title={title}
      onClick={onClick}
      disabled={disabled}
    />
  );
};
const SendIcon = ({ iconSize = "15", onClick }) => {
  return (
    <FiSend
      size={iconSize}
      className="text-blue cursor-pointer"
      onClick={onClick}
    />
  );
};
const BarcodeIcon = ({ iconSize = "15", onClick }) => {
  return (
    <FaBarcode
      size={iconSize}
      className="text-blue cursor-pointer"
      onClick={onClick}
    />
  );
};
const UndoIcon = ({ iconSize = "15", onClick, title = "" }) => {
  return (
    <FaUndo
      size={iconSize}
      className="text-blue cursor-pointer"
      onClick={onClick}
      title={title}
    />
  );
};
const VisualReportIcon = ({
  iconSize = "18",
  onClick,
  title = "Visual Graphical Report",
  className = "text-purple-600 hover:text-purple-800",
}) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 16 16"
      height={iconSize}
      width={iconSize}
      className={`cursor-pointer transition-colors ${className}`}
      onClick={onClick}
      title={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"
      />
    </svg>
  );
};
export {
  EditIcon,
  DeleteIcon,
  EyeIcon,
  PencilIcon,
  CancelIcon,
  PrintIcon,
  EyeSlashIcon,
  SendIcon,
  BarcodeIcon,
  UndoIcon,
  VisualReportIcon,
};
